<template>
    <div>
        <EditAnimal />
    </div>
</template>

<script>
import EditAnimal from '@/components/animal/EditAnimal.vue';
export default {
    components: {
        EditAnimal
    },
    name: 'AnimalEdit'
}
</script>